import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import archiveRouter from "./archiveTabRouter";

export default function ArchiveTab(props) {

  return (
    <TabTemplate 
      router={archiveRouter}
      passData={props.passData}
    />
  )

}